<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Goldbuch |</span>
        <span class="font-weight-light blue--text text--darken-4"
          >Wolf Zahntechnik</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
      </v-btn>

      <div id="nav" class="d-none">
        <router-link to="/">Goldbuch</router-link>
        |
        <router-link to="/about">About</router-link>
      </div>
    </v-toolbar>

    <v-content>
      <router-view />

      <v-snackbar
        v-model="snackbar"
        :timeout="snackbarTimeout"
        :bottom="true"
        :auto-height="true"
        :left="true"
      >
        <span>
          <v-icon :color="snackbarColor" left>{{ snackbarIcon }}</v-icon>
          {{ snackbarText }}
        </span>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
  name: "App",
  components: {},
  data() {
    return {
      snackbar: false,
      snackbarTimeout: 5000,
      snackbarText: null,
      snackbarIcon: null,
      snackbarColor: null
    };
  },
  watch: {
    snackbarText() {
      this.snackbar = true;
      this.snackbarColor = this.snackbarIcon == "error" ? "error" : "success";
    }
  },
  mounted() {
    EventBus.$on("error", err => {
      this.snackbarTimeout = err.length * 35;
      this.snackbarIcon = "error";
      if (this.snackbarTimeout < 5000) this.snackbarTimeout = 5000;
      this.snackbarText = err;
    });

    EventBus.$on("alert", text => {
      this.snackbarTimeout = 5000;
      this.snackbarIcon = "check";
      this.snackbarText = text;
    });
  }
};
</script>

<style lang="scss">
.headline {
  span:last-child {
    padding-left: 4px;
  }
}
</style>
